import styled from 'styled-components';

// export const Body = styled.div`
//   display: flex;
//   background: ${({ theme }) => theme.colors.background_white};
// `;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  .cntAll {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 6rem;
    font-family: 'Futura pt';

    .cnt-image {
      display: flex;
      justify-content: center;

      img {
        width: auto;
        height: auto;
        max-width: 100%;
      }
    }

    .error-text {
      display: flex;
      flex-direction: column;
      justify-content: center;

      div {
        .letter-erro {
          font: normal normal bold 2rem Poppins;
          color: ${({ theme }) => theme.colors.secondary};
          opacity: 1;
        }

        .number-error {
          text-align: center;
          font: normal normal bold 10rem Poppins;
          color: ${({ theme }) => theme.colors.secondary};
          opacity: 1;
          margin-top: -55px;
        }
      }

      .label-error {
        font: normal normal bold 18px/23px Futura PT;
        color: ${({ theme }) => theme.colors.text};
        opacity: 0.8;

        a {
          color: ${({ theme }) => theme.colors.primary};
        }
      }

      .cnt-search {
        display: flex;
        align-items: end;
        padding-top: 15px;

        .text-field {
          width: 100%;
        }

        .icon-search {
          font-size: 30px;
          margin-left: -30px;
          padding-bottom: 5px;
          color: ${({ theme }) => theme.colors.tertiary_500};
        }
      }
    }
  }

  @media (min-width: 800px) and (max-width: 900px) {
    .cntAll {
      padding: 3rem;
    }

    .cntAll .error-text div {
      .letter-erro {
        font: normal normal bold 1.5rem Poppins;
      }

      .number-error {
        font: normal normal bold 8rem Poppins;
        margin-top: -40px;
      }
    }
  }

  @media (max-width: 800px) {
    .cntAll {
      padding: 1rem;
    }

    .cntAll .error-text div {
      .letter-erro {
        font: normal normal bold 1.5rem Poppins;
      }

      .number-error {
        font: normal normal bold 6rem Poppins;
        margin-top: -30px;
      }
    }
  }

  @media (min-width: 450px) and (max-width: 650px) {
    .cntAll {
      flex-direction: column;
      padding: 2rem 7rem;
    }

    .cntAll .error-text {
      margin-top: 10px;

      div {
        .letter-erro {
          font: normal normal bold 2rem Poppins;
        }

        .number-error {
          font: normal normal bold 10rem Poppins;
          margin-top: -30px;
        }
      }
    }
  }

  @media (max-width: 450px) {
    .cntAll {
      flex-direction: column;
      padding: 1rem;
    }

    .cntAll .error-text {
      margin-top: 10px;

      div {
        .letter-erro {
          font: normal normal bold 1.5rem Poppins;
        }

        .number-error {
          font: normal normal bold 8rem Poppins;
          margin-top: -30px;
        }
      }
    }
  }
`;
